module.exports = __webpack_public_path__ + "static/media/img-involvio-thumb@3x.9578ffc0.png";